import { rem } from 'polished'
import React from 'react'
import { ROUTE } from 'shared-constants'
import { DATA_TEST_ID } from 'shared-constants/build/testIds'
import { Button, BUTTON_INTENT, BUTTON_VARIANT } from 'components/Button'
import { Image } from 'components/Image'
import { Flex, Grid } from 'components/Layout'
import { StyledLink } from 'components/Link'
import { H2, Text } from 'components/Typography'
import { GA4_SIGN_IN_AREAS } from 'providers/googleAnalytics'
import { FONT_SIZE, FONT_STACK, SPACE } from 'Theme'

const IMAGE_SIZE = 200
const FIRST_BUTTON_WIDTH = rem(120)
const SECOND_BUTTON_WIDTH = rem(150)

interface EmptyCartProps {
  isNoneSignedIn?: boolean
  onViewShowroom: () => void
}

export const EmptyCart: React.FC<React.PWC<EmptyCartProps>> = ({
  isNoneSignedIn = true,
  onViewShowroom,
}) => (
  <Grid
    data-test-id={DATA_TEST_ID.EMPTY_CART}
    gridTemplateColumns={{ MOBILE: '1fr', TABLET: '1fr max-content' }}
    gridGap={SPACE.PX_15}
    mt={SPACE.PX_40}
    mb={SPACE.PX_30}
  >
    <Flex flexDirection="column">
      <H2>Your cart is empty</H2>
      <Text fontFamily={FONT_STACK.SERIF} fontSize={FONT_SIZE.PX_16}>
        {isNoneSignedIn
          ? 'Looks like your cart is empty. Sign in to view items you may have saved before or shop in our Showroom.'
          : 'Discover 100+ brands and add items to your cart.'}
      </Text>
      <Flex mt={SPACE.PX_20}>
        {isNoneSignedIn && (
          <StyledLink
            data-test-id={DATA_TEST_ID.EMPTY_CART_SIGN_IN_BUTTON}
            intent={BUTTON_INTENT.PRIMARY}
            variant={BUTTON_VARIANT.OUTLINE}
            width={FIRST_BUTTON_WIDTH}
            mr={SPACE.PX_10}
            aria-label="Sign in"
            href={ROUTE.SIGN_IN({
              returnUrl: ROUTE.SHOWROOM_CART(),
              fromUrl: GA4_SIGN_IN_AREAS.EMPTY_CART,
            })}
          >
            Sign In
          </StyledLink>
        )}
        <Button
          width={SECOND_BUTTON_WIDTH}
          onClick={onViewShowroom}
          aria-label="Shop now"
        >
          SHOP NOW
        </Button>
      </Flex>
    </Flex>
    <Flex px={{ MOBILE: 0, TABLET: SPACE.PX_60, DESKTOP: SPACE.PX_80 }}>
      <Image
        src="/emptyCart.svg"
        alt="Shopping cart under the lamp"
        unoptimized
        width={IMAGE_SIZE}
        height={IMAGE_SIZE}
      />
    </Flex>
  </Grid>
)
